import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const AddOrEditImageModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "AddOrEditImageModalContainer" */
      './AddOrEditImageModalContainer'
    ),
  loading: LoadingModal,
});
